import { AxiosInstance } from 'axios';

import { PACKAGE_URLS } from '@/constants/urls';
import { PackageItem } from '@/model/Logistic/PackageItem/PackageItem';

class PackageItemApi {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  createPackageItem = async (packageItemData: PackageItem) => {
    try {
      const response = await this.axiosInstance.post(
        `${PACKAGE_URLS.PACKAGE_ITEMS}`,
        packageItemData,
      );

      return response.data;
    } catch (error) {
      console.error('Error creating package item:', error);
      throw error;
    }
  };

  updatePackageItem = async (packageItemData: Partial<PackageItem>) => {
    try {
      const payload: Record<string, unknown> = {};

      Object.entries(packageItemData).forEach(([key, value]) => {
        // Backend expects missing fields as null instead of undefined
        payload[key] = value === undefined ? null : value;
      });

      const response = await this.axiosInstance.patch(
        `${PACKAGE_URLS.PACKAGE_ITEMS}/${packageItemData.id}`,
        payload,
      );

      return response.data;
    } catch (error) {
      console.error('Error updating package item:', error);
      throw error;
    }
  };

  deletePackageItem = async (packageItemData: PackageItem) => {
    try {
      const response = await this.axiosInstance.delete(
        `${PACKAGE_URLS.PACKAGE_ITEMS}/${packageItemData.id}`,
      );

      return response.data;
    } catch (error) {
      console.error('Error updating package item:', error);
      throw error;
    }
  };

  async getPackageItems(packageId: number) {
    try {
      const response = await this.axiosInstance.get(
        `${PACKAGE_URLS.PACKAGE_ITEMS}?package=${packageId}`,
      );

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getShippedItemsFromTickets(tickets: any) {
    try {
      const params = {
        only_shipped_items: true,
        tickets: tickets.join(','),
      };
      const response = await this.axiosInstance.get(`${PACKAGE_URLS.PACKAGE_ITEMS}`, { params });

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default PackageItemApi;
